import React from 'react';
import PropTypes from 'prop-types';
import { BasicCarousel } from 'components';
import { BPOINT, breakPoints } from 'constants/breakpoints';
import ImageGalleryModal from 'components/modals/image-gallery-modal/image-gallery-modal';
import MediaQuery from 'react-responsive';
import './quick-view-carousel.scss';
import './cursor.scss';

class QuickViewCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showZoomModal: false,
            activeSlideIndex: 0
        };
    }

    render() {
        const {
            images,
            enableZoom,
            carouselStyle,
            fixedHeight,
            ...rest
        } = this.props;
        const { showZoomModal, activeSlideIndex } = this.state;

        const settings = {
            customPaging: function(i) {
                return (
                    <a>
                        <img
                            className="carousel-thumbnail"
                            src={images[i].multiThumbnail}
                        />
                    </a>
                );
            },
            afterChange: index => {
                this.setState({ activeSlideIndex: index });
            },
            initialSlide: activeSlideIndex,
            accessibility: false,
            responsive: [
                {
                    breakpoint: breakPoints[BPOINT.medium].min,
                    settings: {
                        customPaging: function(i) {
                            return <button>{i}</button>;
                        },
                        arrows: false
                    }
                }
            ]
        };

        return (
            <div style={carouselStyle}>
                <BasicCarousel
                    className={`quick-view--carousel ${
                        !fixedHeight && images.length < 2 ? 'mb-0' : ''
                    }`}
                    settings={settings}
                    {...rest}
                    render={() =>
                        images.map((image, index) => (
                            <div
                                key={index}
                                className={`image-gallery-item ${
                                    enableZoom ? 'cursor-zoom-in' : ''
                                }`}>
                                <MediaQuery
                                    minWidth={breakPoints[BPOINT.medium].min}>
                                    <img
                                        className="d-inline-block"
                                        src={
                                            image.normal ||
                                            '//static.tradera.net/internal/site/auction/noImage_344x258.gif'
                                        }
                                        alt={image.alt}
                                    />
                                </MediaQuery>
                                <MediaQuery
                                    maxWidth={breakPoints[BPOINT.small].max}>
                                    <img
                                        className="d-inline-block"
                                        src={
                                            image.medium ||
                                            '//static.tradera.net/internal/site/auction/noImage_344x258.gif'
                                        }
                                        alt={image.alt}
                                    />
                                </MediaQuery>
                                <div
                                    className="quick-view--carousel__hitbox"
                                    onClick={() => {
                                        if (enableZoom) {
                                            this.setState({
                                                showZoomModal: true
                                            });
                                        }
                                    }}
                                />
                            </div>
                        ))
                    }
                />
                {enableZoom &&
                    showZoomModal && (
                        <ImageGalleryModal
                            initialSlideIndex={activeSlideIndex}
                            closeModalCallback={() => {
                                this.setState({ showZoomModal: false });
                            }}
                            images={images}
                        />
                    )}
            </div>
        );
    }
}
QuickViewCarousel.propTypes = {
    images: PropTypes.array.isRequired,
    pageType: PropTypes.string,
    enableZoom: PropTypes.bool,
    carouselStyle: PropTypes.object,
    fixedHeight: PropTypes.bool
};

QuickViewCarousel.defaultProps = {
    enableZoom: false,
    carouselStyle: {},
    fixedHeight: true
};

export default QuickViewCarousel;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/quick-view-carousel/quick-view-carousel.jsx